import { BaseService } from './base.service';
import { PlaybookChapter, PlaybookSearchHit } from '@/types/gamePlan';

// Reads the HQ-authored content fragments that power the Game Plan module.
class GamePlanService extends BaseService {
  constructor() {
    super('/content-fragments');
  }

  /** Owner Playbook — chapters with their fragments, in reading order. */
  getPlaybook(): Promise<PlaybookChapter[]> {
    return this.get<PlaybookChapter[]>('/playbook');
  }

  /**
   * Semantic search over the playbook — fragments ranked by meaning (cosine),
   * most-relevant first, each with a `score`. Scoped to owner-facing game-plan
   * content. Returns a generous candidate set; the UI blends in a lexical
   * boost before final ranking.
   */
  searchPlaybook(query: string): Promise<PlaybookSearchHit[]> {
    return this.post<PlaybookSearchHit[]>('/search', {
      query,
      source: 'game-plan',
      audience: 'owner',
      limit: 30,
      minScore: 0,
    });
  }
}

export const gamePlanService = new GamePlanService();
